import { LinkedCredential } from '../models';
import { DraftCredential } from './draft/draft';
import { VerifiableCredential } from './verifiable/verifiable';

type EnvelopedCredential = DraftCredential | VerifiableCredential;

export class Credential<T extends EnvelopedCredential = EnvelopedCredential> {
    public descriptor = this.credential.descriptor;

    constructor(protected credential: T) {}

    canMapToDraft(): this is Credential<DraftCredential> {
        return this.credential instanceof DraftCredential;
    }

    canMapToVerifiableCredential(): this is Credential<VerifiableCredential> {
        return this.credential instanceof VerifiableCredential;
    }

    toLinkedCredential(): LinkedCredential<unknown> {
        return this.credential.toLinkedCredential();
    }

    toDraft(): DraftCredential {
        if (this.canMapToDraft()) {
            return this.credential;
        }
        throw new Error("Credential can't be mapped to DraftCredential");
    }

    toVerifiableCredential(): VerifiableCredential {
        if (this.canMapToVerifiableCredential()) {
            return this.credential;
        }
        throw new Error("Credential can't be mapped to VerifiableCredential");
    }

    async delete(): Promise<void> {
        await this.credential.delete();
    }

    async send(targetId: string, privateKeyId: string): Promise<void> {
        const verifiableCredential = this.canMapToDraft()
            ? await this.toDraft().issue(privateKeyId)
            : this.toVerifiableCredential();

        await verifiableCredential.send(targetId, privateKeyId);
    }
}
